module.exports = __webpack_public_path__ + "static/media/qr-website-card-preview.99d7f55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-website-card-preview.png
// module id = 371
// module chunks = 3